// extracted by mini-css-extract-plugin
export default {"container":"q1neHP","title":"Fv5w0u"};